

class BrandCategories{
    
    static getBrandCategories(){
        return fetch(`${BASE_URL}api/brand-categories`)
        .then(response => response.json())
        .then((data)=>{
            return data;
        });
    }

    static getBrandCategoryById(id){
        return fetch(`${BASE_URL}api/brand-categories/${id}`)
        .then(response => response.json())
        .then((data)=>{
            return data;
        })
    }
    
}

export default BrandCategories;


